
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/group-rv-bookings/weddings",
      function () {
        return require("private-next-pages/group-rv-bookings/weddings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/group-rv-bookings/weddings"])
      });
    }
  